import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        return;
      }
      // Anchor target not in the DOM yet — every route page is lazy-loaded,
      // so on a fresh load (e.g. a deeplink like /docs/search/lpql-syntax#table)
      // the content mounts after this effect runs. Start at the top, then
      // keep retrying briefly until the target renders.
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      let attempts = 0;
      const MAX_ATTEMPTS = 60; // ~3s at 50ms — covers slow chunk loads
      const timer = window.setInterval(() => {
        const target = document.getElementById(id);
        if (target) {
          window.clearInterval(timer);
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
        } else if (++attempts >= MAX_ATTEMPTS) {
          window.clearInterval(timer);
        }
      }, 50);
      return () => window.clearInterval(timer);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
